import { KText } from '@/ui-library/components';
import { Flex, Icon } from '@chakra-ui/react';
import { FaceSad } from '@kula-ai/icons-core';

export const SchInterviewerFieldNoRecommend = ({ recommendedData }) => {
  const { recommendedUser, isEmptyUsersFromTemplate, hide, isLoading } =
    recommendedData || {};

  let heading, subHeading;

  if (isEmptyUsersFromTemplate) {
    heading = 'Not able to recommend interviewers';
    subHeading =
      'No interviewers or interviewer pool have been selected in the interview plan.';
  } else if (recommendedUser === 'no_interviewer_recommended') {
    heading = 'No interviewer recommendations';
    subHeading =
      'We could not recommend interviewers based on the current interview plan. Try selecting a slot or choose manually';
  }

  if (hide || isLoading || !heading || !recommendedData) return null;

  return (
    <Flex
      flexDir="column"
      gap="8px"
      mt="12px"
      bgColor="secondary-50"
      borderRadius="6px"
      p="12px"
    >
      <Flex gap="6px">
        <Icon
          w="20px"
          h="20px"
          // @ts-expect-error -- pre-existing type debt (extraction move)
          as={FaceSad}
          color="secondary-700"
        />
        <KText variant="heading_4">{heading}</KText>
      </Flex>
      <KText>{subHeading}</KText>
    </Flex>
  );
};
